export default {
    loading: {
        module: false
    },
    params: {
        type_query: "1",
        branchoffice_id: null,
        date :[]
    },
    params_documents:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
    },
    report_sales_p:[],
    radiansState:[],
    radiansStateNames:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/report-sales-purchases/state.js